import { useTranslation } from 'react-i18next';
import { ActivationRequestFailedError, provisionRsim } from './api/rSimActionsApi';
import { ConfirmActionDialog } from 'common/components/ConfigurableTable/Components/Actions/ConfirmActionDialog';
import { useState } from 'react';
import {
  ActivationError,
  ActivationSnackbar,
} from 'common/components/Activation/ActivationSnackbar';
import { useMutation } from '@tanstack/react-query';
import { AuthError } from 'auth/utils';
import {
  GoogleTagManagerActions,
  sendGoogleTagManagerAction,
} from 'src/common/utils/sendGoogleTagManagerAction';

type DeactivationDialogProps = {
  data: any;
  open: boolean;
  onClose: () => void;
};

export const DeactivationDialog = ({ data, open, onClose }: DeactivationDialogProps) => {
  const { t } = useTranslation();

  const [error, setError] = useState<ActivationError | null>(null);

  const { mutate } = useMutation({
    mutationKey: ['rsim-provisisioning'],
    mutationFn: async () => {
      await provisionRsim([data.connectionId], false);
    },
    retry: 0,
    onError: (error) => {
      if (error instanceof AuthError) {
        throw error;
      } else if (error instanceof ActivationRequestFailedError) {
        setError({
          title: t('common.activationRequestFailed'),
          description: [
            t('common.anotherRequestStillInProgress'),
            t('simInventory.pleaseTryAgainLater'),
          ],
        });
      } else {
        setError({ title: error.message, description: [] });
      }
      sendGoogleTagManagerAction(GoogleTagManagerActions.SingleRSimProductDeactivationFailure);
    },
    onSuccess: () => {
      sendGoogleTagManagerAction(GoogleTagManagerActions.SingleRSimProductDeactivationSuccess);
    },
  });

  return (
    <>
      <ConfirmActionDialog
        open={open}
        data={data}
        onClose={onClose}
        submit={async () => mutate()}
        message={`${t('rSimInventory.deactivationEid')} ${data?.euicc}`}
        title={t('rSimInventory.deactivation')}
      />
      <ActivationSnackbar error={error} setError={setError} />
    </>
  );
};
